module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-07a477c5.png";